import { Col, message, Row, Divider, DatePicker } from "antd";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import OtpCard from "../../../Components/OTPCArd";
import { SectionCardWrapper } from "../../../Components/UI/SectionCardWrapper";
import {
  CustomLabel,
  error_message,
  maskPhoneNumber,
  regex,
} from "../../../Constant";
import { withScroll } from "../../../HOC";
import { postApi } from "../../../Services/apiService";
import {
  GET_OTP,
  Validate_Otp,
} from "../../../Services/endpoints";
import FooterButton from "../../Footer";
import InputFormComponent from "../InputFormComponentBelstar";
import CheckboxConsentBelstar from "./CheckBoxConsentBelstar";
import CustomSelect from "../../../Components/CustomSelectBelstar";
import ContentComponent from "./ContentComponent";
import { decrypt, encrypt } from "../../../Services/AESEncryptionDecryption";

dayjs.extend(customParseFormat);
const dateFormat = 'DD/MM/YYYY';

const SummaryPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showOtp, setShowOtp] = useState(false);
  const [otpValue, setOtpValue] = useState(0);
  const [error, setError] = useState({
    pancard: false,
    email: false,
    mobile: false,
  });
  const [showProceedBtn, setShowProceedBtn] = useState(true);
  const [otpId, setOtpId] = useState("");
  const [inputAmount, setInputAmount] = useState("");
  const [userData, setUserData] = useState({
    disclaimerCheck: true,
    tncCheck: true,
    pancard: "",
    email: "",
    mobile: "",
  });

  let { tncCheck, pancard, email, mobile } = userData;

  const belstarData = useSelector((state) => state.belstarDetails);

  let { memberSalutation, memberName, memberLastName, memberEmail, memberMobile, memberDOB, memberGender, memberAddress1, memberAddress2, memberAddress3, pinCode, loanId, branchId, sumInsured, nomineeName, nomineeAge, nomineeRelationship, uniqueIdentifier, nomineeDOB, productName, preExistingDisease } = belstarData;
  // memberMobile = 7459027503;
  console.log(memberMobile, belstarData, "memberMobile")

  const getOTPApi = async () => {
    const reqObject = {
      phoneNumber: memberMobile,
      uniqueIdentifier: uniqueIdentifier,
      isUpiAsba: false,
    };
    const encryptedPayload = encrypt(JSON?.stringify(reqObject));
    try {
      const res = await postApi(GET_OTP, {
        encodedString: encryptedPayload
      });
      const decryptedRes = JSON?.parse(decrypt(res?.data?.response))
      if (decryptedRes?.otpId) {
        setOtpId(decryptedRes?.otpId);
        setShowOtp(true);
        return;
      }
      message.error(res?.data?.error?.errorMessage);
    } catch (err) {
      console?.error(err)
    }
  };

  const validateOTP_Api = async () => {
    const reqObject = {
      otpId: otpId,
      enteredOtp: otpValue,
    };
    const encryptedPayload = encrypt(JSON?.stringify(reqObject));
    try {
      const res = await postApi(Validate_Otp, {
        encodedString: encryptedPayload
      });
      const decryptedRes = JSON?.parse(decrypt(res?.data?.response))
      if (!res?.data?.error && decryptedRes?.enteredOTPValid && (decryptedRes?.otpId === otpId)) {
        setShowOtp(false);
        setOtpValue(0);
        setShowProceedBtn(false);
        message.success("Mobile number is successfully verified");
        return;
      }
      message.error(error_message.Invalid_Otp);
    } catch {
      message.error(error_message.common_error);
    }
  };

  const paymentPageRedirection = () => {
    // let error = regex.PAncard.test(pancard);
    // if (amount > 100000 && !error) {
    if (tncCheck === false) {
      return message.error(error_message.tnc_error);
    }
    // dispatch({ type: SET_USER_DATA, payload: { ...userData, inputAmount: inputAmount } })
    navigate("/payment", { replace: true });
  }

  return (
    <div className="container">
      <Row justify="space-around" className={"cls_mghuntew_699b44"}>
        <Col lg={24} md={20} xs={24}>
          <SectionCardWrapper>
            <Row>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Member Salutation</CustomLabel>
                <CustomSelect
                  style={{ width: "75%" }}
                  // selectOption={getSalutationOptions()}
                  // placeholder="Select Member Salutation"
                  // onSelectClick={(e) => {
                  //   console.log(e, "salutation")
                  //   setMemberSalutation(e);
                  // }}
                  value={memberSalutation}
                  disabled={true}
                />
                <Divider />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Member Name</CustomLabel>
                <InputFormComponent
                  label={"Member Name"}
                  className="user-input"
                  name="Member Name"
                  placeholder="Name"
                  regex={regex.name}
                  value={memberName}
                  disabled={true}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Member Last Name</CustomLabel>
                <InputFormComponent
                  label={"Member Last Name"}
                  className="user-input"
                  name="Member Last Name"
                  placeholder="Name"
                  regex={regex.name}
                  value={memberLastName}
                  disabled={true}
                // onChange={(e) =>
                //   setMemberLastName(e.target.value)
                // }
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Member Email</CustomLabel>
                <InputFormComponent
                  label={"Member Email"}
                  className="user-input"
                  name="Member Email"
                  placeholder="Email"
                  regex={regex.email}
                  value={memberEmail}
                  disabled={true}
                // onChange={(e) =>
                //   setMemberEmail(e.target.value)
                // }
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Member Mobile</CustomLabel>
                <InputFormComponent
                  label={"Member Mobile"}
                  className="user-input"
                  name="Member Mobile"
                  placeholder="****45***"
                  value={memberMobile}
                  // error={error.memberMobileError}
                  maxlength={10}
                  msg={"Enter valid Phone Number"}
                  regex={regex.numeric_only}
                  disabled={true}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Member DOB</CustomLabel>
                <DatePicker style={{ width: '75%' }} defaultValue={null}
                  format={dateFormat} disabled={true} value={memberDOB ? dayjs(memberDOB) : null}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Member Gender</CustomLabel>
                <CustomSelect
                  style={{ width: "75%" }}
                  // selectOption={getGenderOptions()}
                  // placeholder="Select From Below Option"
                  // onSelectClick={(e) => {
                  //   setMemberGender(e);
                  // }}
                  value={memberGender}
                  disabled={true}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Member Address1</CustomLabel>
                <InputFormComponent
                  label={"Member Address1"}
                  className="user-input"
                  name="Member Address1"
                  value={memberAddress1}
                  // error={error.emailError}
                  maxlength={60}
                  msg={"Enter Address"}
                  regex={regex.common}
                  disabled={true}
                  placeholder="Address 1"
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Member Address2</CustomLabel>
                <InputFormComponent
                  label={"Member Address2"}
                  className="user-input"
                  name="Member Address2"
                  value={memberAddress2}
                  // error={error.emailError}
                  maxlength={60}
                  msg={"Enter Address"}
                  regex={regex.common}
                  disabled={true}
                  placeholder="Address 2"
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Member Address3</CustomLabel>
                <InputFormComponent
                  label={"Member Address3"}
                  className="user-input"
                  name="Member Address3"
                  value={memberAddress3}
                  // error={error.emailError}
                  maxlength={60}
                  msg={"Enter Address"}
                  regex={regex.common}
                  disabled={true}
                  placeholder="Address 3"
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Member PinCode</CustomLabel>
                <InputFormComponent
                  label={"Member PinCode"}
                  className="user-input"
                  name="Pincode"
                  value={pinCode}
                  // error={error.emailError}
                  maxlength={60}
                  msg={"Enter Pincode"}
                  regex={regex.common}
                  disabled={true}
                  placeholder="******"
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>LoanId</CustomLabel>
                <InputFormComponent
                  label={"LoanId"}
                  className="user-input"
                  name="LoanId"
                  value={loanId}
                  // error={error.emailError}
                  maxlength={60}
                  msg={"Enter LoanId"}
                  regex={regex.common}
                  placeholder="LoanId"
                  disabled={true}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Product Name</CustomLabel>
                <CustomSelect
                  style={{ width: "75%" }}
                  // selectOption={getProductOptions()}
                  disabled={true}
                  // placeholder="Select From Below Option"
                  // onSelectClick={(e) => {
                  //   setProductName(e);
                  // }}
                  value={productName}
                // disabled={disableField?.payFor}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Sum Insured</CustomLabel>
                <InputFormComponent
                  label={"Sum Insured"}
                  className="user-input"
                  name="Sum Insured"
                  value={sumInsured}
                  // error={error.emailError}
                  maxlength={60}
                  msg={"Enter Sum Insured"}
                  regex={regex.common}
                  placeholder="Sum Insured"
                  disabled={true}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Branch ID</CustomLabel>
                <InputFormComponent
                  label={"Branch ID"}
                  className="user-input"
                  name="Branch ID"
                  value={branchId}
                  // error={error.emailError}
                  maxlength={60}
                  msg={"Enter Branch Id"}
                  regex={regex.common}
                  placeholder="Branch Id"
                  disabled={true}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Nominee Name</CustomLabel>
                <InputFormComponent
                  label={"Nominee Name"}
                  className="user-input"
                  name="Nominee Name"
                  value={nomineeName}
                  disabled={true}
                  // error={error.emailError}
                  maxlength={60}
                  msg={"Enter Nominee Name"}
                  regex={regex.common}
                  placeholder="Nominee Name"
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Nominee DOB</CustomLabel>
                <DatePicker style={{ width: '75%' }} defaultValue={null}
                  format={dateFormat} disabled={true} value={nomineeDOB ? dayjs(nomineeDOB) : null}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <CustomLabel>Pre-Existing Disease(If any)</CustomLabel>
                <InputFormComponent
                  label={"Pre-Existing Disease"}
                  className="user-input"
                  name="Pre-Existing Disease"
                  value={preExistingDisease}
                  // error={error.emailError}
                  maxlength={60}
                  disabled={true}
                  msg={"Enter Pre-Existing Disease"}
                  regex={regex.common}
                  placeholder="Pre-Existing Disease"
                />
              </Col>
              <Col xs={24} sm={12}>
                <CustomLabel>Nominee Relationship With Member</CustomLabel>
                <CustomSelect
                  style={{ width: "75%" }}
                  disabled={true}
                  value={nomineeRelationship}
                // disabled={disableField?.payFor}
                />
              </Col>
            </Row>
            {memberMobile ? (
              <ContentComponent
                label={"Mobile Number of payer"}
                value={maskPhoneNumber(memberMobile)}
                isMobileNumber={true}
                onAPiCall={getOTPApi}
                showOtp={showOtp}
                showProceedBtn={showProceedBtn}
              // disableNext={!parseInt(userDBAmount) && !Boolean(inputAmount)}
              />
            ) : (
              <>
                <InputFormComponent
                  label={"Mobile Number of payer"}
                  className="user-input"
                  name="Mobile Number"
                  regex={regex.numeric_only}
                  error={error.mobile}
                  msg={"Enter valid Phone Number"}
                  value={mobile}
                  disabled={!showProceedBtn}
                  showProceedBtn={showProceedBtn}
                  placeholder="12****232"
                  maxlength={10}
                />
                {mobile && mobile.length > 9 && showProceedBtn && (
                  <Row>
                    <Col lg={10} md={12} xs={0}></Col>
                    <Col lg={10} md={12} xs={24}>
                      <FooterButton
                        hideBack={true}
                        nextLabel={showOtp ? "Resend OTP" : "Send OTP"}
                        onNext={getOTPApi}
                      // disableNext={!parseInt(userDBAmount) && !Boolean(inputAmount)}
                      />
                    </Col>
                  </Row>
                )}
              </>
            )}
            {showOtp && (
              <Col
                lg={24}
                md={24}
                xs={24}
                span={24}
                className={"cls_mghuntex_e4a09f"}
              >
                <Row justify="center">
                  <Col lg={12} xs={24}>
                    <div>
                      <OtpCard
                        validateOtp={validateOTP_Api}
                        otpValue={otpValue}
                        setOtpValue={setOtpValue}
                        mobileNo={mobile}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            )}
          </SectionCardWrapper>
          {/* <Row
            justify="space-between"
            align="top"
            gutter={[0, { lg: 40 }]}
            className={"cls_mghuntex_ec4138"}
          >
            <CheckboxConsentBelstar
            />
          </Row> */}
          <div>
            <FooterButton
              hideBack={true}
              nextLabel="Review & Pay"
              onNext={paymentPageRedirection}
              disableNext={showProceedBtn}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default withScroll(SummaryPage);
